import React from 'react';
import { Check } from 'lucide-react';
import { cx, disc } from './classes';

/**
 * Takes Fix next's place when nothing needs fixing. Never invent an issue to fill the space.
 */
export const NothingUrgent = ({ children = 'This is ready to sit in the mix. Ask below if you want to push it further.' }) => (
  <div className="flex items-start gap-space-3 p-space-4 rounded-radius-md bg-base">
    <span className={cx(disc, 'bg-raised text-ink-soft')}>
      <Check size={16} strokeWidth={2.5} aria-hidden="true" />
    </span>
    <div className="flex flex-col gap-space-1 font-text">
      <span className="text-body-strong text-ink">Nothing urgent</span>
      <span className="text-small text-ink-soft">{children}</span>
    </div>
  </div>
);
